import mute from '../assets/mute.png';
import volume from '../assets/volume.png';
import styles from './MuteButton.module.scss'
import appStyles from '../App.module.scss';

export interface IMuteButtonProps {
    isMuted?: boolean;
    onClick?: () => void;
}

export function MuteButton(props: IMuteButtonProps) {
    const { isMuted, onClick } = props;

    return (
        <div className={styles.muteButton}>
            {
                isMuted ? 
                <button className={appStyles.basicButton} onClick={onClick} aria-label='Click to unmute'>
                    <img className={styles.muteImg} src={mute} alt='mute' />
                </button> :
                <button className={appStyles.basicButton} onClick={onClick} aria-label='Click to mute'>
                    <img className={styles.muteImg} src={volume} alt='sound' />
                </button>
            }
        </div>
    );
}